import { useAuth } from '@/context/Auth';
import { usePostMessageListener } from '@/hooks/usePostMessageListener';
import { getGenetecPostMessage } from '@/utils/helpers';
import { useCallback } from 'react';

const postMessageConnection = getGenetecPostMessage({ source: 'genetec', type: 'connection' });

export const usePowerAppsTokenRefresh = () => {
  const { resetToken } = useAuth();

  const handleTokenRefreshMessage = useCallback(
    (props: any) => {
      const data = postMessageConnection(props);
      if (!data) return;

      // Accept only: true (boolean) or 'true' (string), and common shapes
      const candidates = [data?.tokenRefresh, data?.data?.tokenRefresh];
      const shouldRefresh = candidates.some(
        (candidate) => candidate === true || candidate === 'true',
      );

      if (shouldRefresh) resetToken();
    },
    [resetToken],
  );

  usePostMessageListener(handleTokenRefreshMessage);
};
